export default "__VITE_ASSET__CgrJUKF4__"